import { Container, Row, Col } from "react-bootstrap";

function AboutMe() {
  return (
    <>
      <Container fluid className="aboutme px-0 pt-5 pb-5 mb-10">
        <Row className="g-0 px-5">
          <Col
            lg={6}
            md={12}
            className="d-flex justify-content-center align-items-center py-5"
          >
            <img src="./about.jpeg" alt="" className="about-img" />
          </Col>
          <Col lg={6} md={12} className="d-flex align-items-center">
            <p>
              <span className="fw-bold">
                Hi, I am Prerna!
                <br />— Founder and Psychotherapist at ScopeWithin
              </span>
              <br />
              <br />
              As a trauma-informed and neurodivergence inclusive
              psychotherapist, I believe in doing deep work in therapy. My
              approach is eclectic, holistic, and collaborative. My therapeutic
              alliance is grounded in openness, respect, honesty, trust, and
              humour. I consciously work towards providing a safe,
              non-judgmental space in my sessions. My aim is to help you feel
              empowered, live freely and authentically, thrive in your
              relationships with yourself and others, experience healing and
              change, and uncover your purpose in life. I have a postgraduate
              degree in Master of Science, Clinical and Health Psychology, from
              United Kingdom, and an undergraduate degree in Bachelor of Arts,
              Psychology (H) from India. In addition, I hold many certificates
              in the field, and I'm always learning more to grow. To get in
              touch with me, kindly fill in the form below.
            </p>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default AboutMe;
